import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import commonHandler, { ResponseOrError } from './common-handler';
import { getErrorJson } from '@mm/utils';
import { unbusyAll } from '../actions/commonActions';

export const messengerAdsHandler =
  (dispatch: Dispatch<StoreState>) => async (error: ResponseOrError) => {
    if (error instanceof Response) {
      const responseErrorBody = await getErrorJson(error);
      if (error.status === UNPROCESSABLE_ENTITY && responseErrorBody.errors) {
        dispatch(unbusyAll());
        return responseErrorBody.errors;
      }
    }
    return commonHandler(dispatch)(error);
  };
